import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../utils/Verifiers.jsx';
import RenglonInventarioCampo from './Componentes/RenglonInventarioCampo';
import SelectorFiltrosCampo from './Componentes/SelectorFiltrosCampo';

const InventarioCampoV2 = () => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [paginador, setpaginador] = useState({ page: 1, pages: 0, total: 0, limit: 100, estado: "PROCESO" });
    const [filtros, setfiltros] = useState({ camas: [], colores: [], flores: [], orden: [], variedades: [], ranchos: [], 'semana trasplante': [], 'semana siembra': [], 'semana corte': [], tuneles: [], valvulas: [], usuarios: [], estado: [] });
    const [inventarios, setinventarios] = useState([]);
    const [detalles, setdetalles] = useState(null);
    const [filtrosSeccion, setfiltrosSeccion] = useState();
    const nombreFiltro = [
        { name: 'flores', field: 'flor' },
        { name: 'variedades', field: 'variedad' },
        { name: 'colores', field: 'color' },
        { name: 'semana trasplante', field: 'semana_trasplante' },
        { name: 'semana corte', field: 'semana_cosecha' }
    ];
    const keys = [
        { key: 'bloque', name: 'BLOQUE' },
        { key: 'numero_plantas', name: 'PLANTAS' },
        { key: 'plantas_ejecucion', name: 'P. EJEC.' },
        { key: 'semana_siembra', name: 'S. SIEMB.' },
        { key: 'fecha_siembra', name: 'FEC. SIEMB.' },
        { key: 'semana_trasplante', name: 'S. TRASP.' },
        { key: 'fecha_trasplante', name: 'FEC. TRASP.' },
        { key: 'dia_trasplante', name: 'DÍA TRASP.' },
        { key: 'semana_cosecha', name: 'S. CORTE' },
        { key: 'fecha_cosecha', name: 'FEC. CORTE' },
        { key: 'dia_cosecha', name: 'DÍA CORTE' },
        { key: 'rancho', name: 'RANCHO' },
        { key: 'valvula', name: 'VALVULA' },
        { key: 'tunel', name: 'TUNEL' },
        { key: 'cama_inicio', name: 'CAMA INI.' },
        { key: 'cama_fin', name: 'CAMA FIN' }
    ]

    useEffect(() => {
        getInventarios();
        getFiltros();
    }, []);

    const getFiltros = async () => {
        let resp = await Verifiers.getDataAPI('/campo/v2/inventarios/filtros', paginador, setloader, setdialog);
        if (!resp) return;
        setfiltros(resp.data);

    }

    const getInventarios = async (data = { ...paginador }) => {
        let resp = await Verifiers.getDataAPI('/campo/v2/inventarios/get', data, setloader, setdialog);
        if (!resp) return;
        data.pages = resp.pages;
        data.total = resp.total;
        setpaginador(data);
        setinventarios(resp.data);
    }

    const paginas = () => {
        let pg = [];
        for (let i = 0; i < paginador.pages; i++) pg.push(i + 1);
        return pg;
    }

    const changePage = (back) => {
        let p = { ...paginador };
        if (back && p.page > 1) {
            p.page--;
            getInventarios(p);
        } else if (!back && p.page < p.total) {
            p.page++;
            getInventarios(p);
        }
    }

    const jumpPage = (e) => {
        let newPage = parseInt(e.target.value);
        if (paginador.page != newPage) {
            let p = { ...paginador };
            p.page = newPage;
            getInventarios(p);
        }
    }

    const filtrar = (e) => {
        let { name, value } = e.target;
        let pp = { ...paginador };
        pp[name] = +value;
        getInventarios(pp);
    }

    const concluirMultiplesRegistrosPaso1 = () => {
        const totalConcluir = inventarios.reduce((acc, inv) => acc + (inv.estado === "PROCESO" ? 1 : 0), 0);
        if (totalConcluir === 0) {
            Verifiers.activeDialog(setdialog, "No hay registros en proceso para concluir en esta página de resultados", "INVENTARIO CAMPO");
            return;
        }
        setdialog({
            show: true,
            title: "CONFIRMAR CONCLUSIÓN",
            body: `¿Estás seguro de que deseas concluir los ${totalConcluir} registros que están en proceso? Esta acción no se puede deshacer.`,
            respYes: "Sí, concluir",
            respNot: "No, cancelar",
            funct: (resp) => {
                if (resp) {
                    concluirMultiplesRegistrosPaso2();
                }
            }
        });
    }

    const concluirMultiplesRegistrosPaso2 = async () => {
        const ids = inventarios.filter(inv => inv.estado === "PROCESO").map(inv => inv.id);

        const resp = await Verifiers.getDataAPI('/campo/v2/inventario_campo/concluir/multiple', { ids }, setloader, setdialog);
        if (!resp.estatus) {
            return;
        }
        Verifiers.activeDialog(setdialog, resp.msj ?? "Registros concluidos exitosamente", "INVENTARIO CAMPO");
        getInventarios();
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-200'>
                    <div className='w-100 teext-CENTER text-xs text-bold m-1'>MÁS OPCIONES DE FILTRADO</div>
                    <button className='btn btn-sm btn-light shadow w-100 border border-2 border-warning text-bold' onClick={() => setfiltrosSeccion({ ...paginador })} >Abrir galeria de filtros</button>
                </div>
                {
                    nombreFiltro.map((filtro, i) => <div key={i + filtro} className='form-group m-1 bw-150 '>
                        <div className='w-100 text-satart ps-2 text-xs text-bold'>{filtro.name.toUpperCase()}</div>
                        <select className='form-control form-control-sm' value={paginador[filtro.field] ?? ""} name={filtro.field} onChange={filtrar}>
                            <option value='' >Todo</option>
                            {filtros[filtro.name].map((f, j) => <option key={j + filtro.name} value={f.value}>{f.nombre}</option>)}
                        </select>
                    </div>)
                }

                <div className='bw-150 p-1 m-0 d-flex align-items-center justify-content-center flex-column'>
                    <button className='btn btn-danger bg-red4 shadow w-100 btn-sm round-m ' onClick={concluirMultiplesRegistrosPaso1}>
                        CONCLUIR <span className='text-bold ms-2 me-2'>{inventarios.reduce((acc, inv) => acc + (inv.estado === "PROCESO" ? 1 : 0), 0)}</span> REG.
                    </button>
                </div>

                <div className='form-group p-1 text-center bw-200'>
                    <label className='text-bold text-s w-100'>
                        <span className='text-xs'>Página:</span> ({paginador.page} / {paginador.pages})
                        <span className='ms-2 text-xs'>Registros:</span> {paginador.total}
                    </label>
                    <div className="btn-group w-100 bg-warning" role="group" >
                        <button type="button" className="w-30 btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white"
                            disabled={paginador.page <= 1}
                            onClick={() => { changePage(true) }}>❮</button>
                        <select className='form-control form-control-sm text-center border w-40' value={paginador.page} onChange={jumpPage}>
                            {
                                (paginas() ?? []).map((pag, i) => {
                                    return (
                                        <option value={pag} key={i + "pagina" + pag} className='ps-3 pe-3'>{pag}</option>
                                    )
                                })
                            }
                        </select>
                        <button type="button" className="w-30 btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white"
                            disabled={paginador.page >= paginador.pages}
                            onClick={() => changePage(false)}>❯</button>
                    </div>
                </div>

                <div className='w-100 pt-0 p-1 bg-black round-bottom-m shadow-multi' style={{ padding: '5px' }}>
                    <div className='w-100 round-bottom-m p-0 bg-white overflow' style={{ maxHeight: "calc(75vh - 5px)" }}>
                        {inventarios.length > 0 && <table className='table table-sm'>
                            <thead>
                                <tr>
                                    {keys.map((key, i) => <th key={i} className='text-bold text-white bg-black nowrap text-center ps-2 pe-2'>{key.name}</th>)}
                                    <th className='text-bold text-white bg-black nowrap text-center ps-2 pe-2'>MÁS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inventarios.map((inv, i) =>
                                    <React.Fragment key={i}>
                                        <RenglonInventarioCampo data={inv} detalles={detalles} index={i} setdetalles={setdetalles} keys={keys} refresh={() => getInventarios()} />
                                    </React.Fragment>
                                )}
                            </tbody>
                        </table>}
                    </div>
                </div>


            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
            {filtrosSeccion && <SelectorFiltrosCampo paginador={filtrosSeccion} filtros={filtros} close={(pag) => {
                if (pag) getInventarios(pag);
                setfiltrosSeccion(null);
            }} />}
        </div>
    )
}

export default InventarioCampoV2;
